import { connectAdvanced } from 'react-redux';
import mapValues from 'lodash/mapValues';
import mapKeys from 'lodash/mapKeys';
import camelCase from 'lodash/camelCase';
import isFunction from 'lodash/isFunction';
import identity from 'lodash/identity';

/**
 * Get a hash of feature flags from Redux state and update the keys to camelcase.
 *
 * @param {*} state Redux state.
 * @returns {Object}
 */
function getCamelCasedFlags(state) {
  const flags = state.featureFlags.items;
  const updatedKeys = mapKeys(flags, (value, key) => camelCase(key));
  return mapValues(updatedKeys, 'isEnabled');
}

/**
 *
 * @param {Function} mapFlagsToProps Similar to `mapStateToProps`, receive a hash of `flags` to compute list of new props.
 *
 * @see https://mokapos.atlassian.net/wiki/spaces/MT/pages/10518628/Feature+Flags
 */
function withFeatureFlags(mapFlagsToProps) {
  if (!isFunction(mapFlagsToProps)) {
    // eslint-disable-next-line no-console
    console.warn(
      'Missing `mapFlagsToProps` for `withFeatureFlags` HOC. Consider removing the HOC?'
    );
    return identity;
  }

  function selectorFactory() {
    return (state, ownProps) => {
      const flags = getCamelCasedFlags(state);
      const props = mapFlagsToProps(flags, ownProps);
      return {
        ...props,
        ...ownProps,
      };
    };
  }

  // This helps debugging with React devtools
  const getDisplayName = name => `withFeatureFlags(${name})`;
  return connectAdvanced(selectorFactory, {
    getDisplayName,
    methodName: 'withFeatureFlags',
  });
}

export default withFeatureFlags;
